import { render, staticRenderFns } from "./DeliveryBoardView.vue?vue&type=template&id=2621bc3a&"
import script from "./DeliveryBoardView.vue?vue&type=script&lang=js&"
export * from "./DeliveryBoardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports